import { useFieldArray, useFormContext } from '@astro/forms'
import { TextInput } from '../fields'

const CURRENT_YEAR = new Date().getFullYear()

export default function StepEducation() {
  const { control, formState: { errors } } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'education',
    rules: { required: 'Add at least one education entry.' },
  })

  return (
    <div className="step-panel space-y-4">
      <div className="p-3 rounded-xl bg-amber-50/60 border border-amber-800/15 flex items-start gap-2.5">
        <span className="text-sm">🎓</span>
        <p className="text-xs text-stone-500 font-light leading-relaxed">
          Add your astrology &amp; academic qualifications. You can add more than one entry.
        </p>
      </div>

      <div className="space-y-4">
        {fields.map((row, i) => (
          <div key={row.id} className="ar-repeat-row">
            <button type="button" className="ar-remove-row" onClick={() => remove(i)} aria-label="Remove entry">
              ✕
            </button>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pr-6">
              <TextInput
                name={`education.${i}.degree`}
                label="Degree / Qualification"
                placeholder="Jyotish Acharya"
                rules={{ required: 'Qualification is required.' }}
              />
              <TextInput
                name={`education.${i}.institution`}
                label="Institution"
                placeholder="Institute name"
                rules={{ required: 'Institution is required.' }}
              />
              <TextInput
                name={`education.${i}.year`}
                type="number"
                label="Year of Completion"
                placeholder="2015"
                rules={{
                  required: 'Year is required.',
                  min: { value: 1950, message: 'Enter a year after 1950.' },
                  max: { value: CURRENT_YEAR, message: `Enter a year up to ${CURRENT_YEAR}.` },
                }}
              />
            </div>
          </div>
        ))}
      </div>

      {errors.education?.root && <p className="ar-error">{errors.education.root.message}</p>}

      <button
        type="button"
        onClick={() => append({ degree: '', institution: '', year: '' })}
        className="w-full border border-dashed border-goldAccent/40 text-goldAccent hover:bg-goldPrimary/5 font-bold text-xs tracking-wider uppercase py-3 rounded-xl transition-colors flex items-center justify-center gap-2"
      >
        <span className="text-base leading-none">+</span> Add Education
      </button>
    </div>
  )
}
